import { render, staticRenderFns } from "./ItemOpenMethodIcon.vue?vue&type=template&id=02797cfb&scoped=true"
import script from "./ItemOpenMethodIcon.vue?vue&type=script&lang=js"
export * from "./ItemOpenMethodIcon.vue?vue&type=script&lang=js"
import style0 from "./ItemOpenMethodIcon.vue?vue&type=style&index=0&id=02797cfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02797cfb",
  null
  
)

export default component.exports